(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'DOMContentLoaded',
    () => {
      document.querySelectorAll('[data-collection-description]').forEach((description) => {
        if (!(description instanceof HTMLElement)) return;

        const content = description.querySelector('[data-collection-description-content]');
        const button = description.querySelector('[data-collection-description-toggle]');

        if (!(content instanceof HTMLElement) || !(button instanceof HTMLButtonElement)) return;

        const collapsedHeight = parseFloat(getComputedStyle(content).maxHeight);
        const previousMaxHeight = content.style.maxHeight;

        content.style.maxHeight = 'none';
        const expandedHeight = content.getBoundingClientRect().height;
        content.style.maxHeight = previousMaxHeight;

        const shouldCollapse = expandedHeight > collapsedHeight + 4;

        description.setAttribute('data-ready', '');
        description.toggleAttribute('data-can-expand', shouldCollapse);

        if (!shouldCollapse) return;

        button.addEventListener('click', () => {
          const isExpanded = description.toggleAttribute('data-expanded');
          button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          button.textContent = isExpanded ? button.dataset.labelLess ?? '' : button.dataset.labelMore ?? '';
        });
      });
    },
    { once: true }
  );

  // Child collection links: on desktop (mouse) only the first rows are shown, with a "Show more (+N)" toggle.
  // The rows are clipped with CSS from the start (no layout shift); this script measures the exact height of
  // those rows, counts the hidden links and keeps them out of the tab order while collapsed.
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const desktopQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      const VISIBLE_ROWS = 2;

      document.querySelectorAll('[data-collection-chips]').forEach((list) => {
        if (!(list instanceof HTMLElement)) return;

        const toggle = list.parentElement?.querySelector('[data-collection-chips-toggle]');
        if (!(toggle instanceof HTMLButtonElement)) return;

        const items = /** @type {HTMLElement[]} */ ([...list.children]);
        let expanded = false;
        let lastWidth = 0;

        const layout = () => {
          items.forEach((item) => item.removeAttribute('inert'));

          if (!desktopQuery.matches) {
            toggle.hidden = true;
            return;
          }

          // The list is positioned, so offsetTop is relative to it.
          const rowTops = [...new Set(items.map((item) => item.offsetTop))].sort((a, b) => a - b);
          list.setAttribute('data-ready', '');

          if (rowTops.length <= VISIBLE_ROWS) {
            list.removeAttribute('data-collapsible');
            toggle.hidden = true;
            return;
          }

          const lastVisibleRowTop = rowTops[VISIBLE_ROWS - 1];
          const hiddenItems = items.filter((item) => item.offsetTop > lastVisibleRowTop);
          const lastVisibleRowBottom = Math.max(
            ...items.filter((item) => item.offsetTop === lastVisibleRowTop).map((item) => item.offsetTop + item.offsetHeight)
          );
          const paddingBottom = parseFloat(getComputedStyle(list).paddingBottom) || 0;

          list.style.setProperty('--chips-collapsed-height', `${lastVisibleRowBottom + paddingBottom}px`);
          list.setAttribute('data-collapsible', '');
          list.toggleAttribute('data-expanded', expanded);
          if (!expanded) hiddenItems.forEach((item) => item.setAttribute('inert', ''));

          toggle.hidden = false;
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded
            ? toggle.dataset.labelLess ?? ''
            : `${toggle.dataset.labelMore ?? ''} (+${hiddenItems.length})`;
        };

        toggle.addEventListener('click', () => {
          expanded = !expanded;
          layout();
        });

        // Re-measure when the width changes (resize, fonts loaded); height changes come from the toggle itself.
        new ResizeObserver(([entry]) => {
          const width = Math.round(entry.contentRect.width);
          if (width === lastWidth) return;
          lastWidth = width;
          layout();
        }).observe(list);

        desktopQuery.addEventListener('change', layout);
      });
    },
    { once: true }
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-bundle-directory"] && !Shopify.designMode) return;
  try {
    (() => {
    const copyTextToClipboard = async (text) => {
      if (!text) return false;

      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (_error) {
          // Fall back to a temporary textarea when clipboard API is unavailable.
        }
      }

      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();

      let copied = false;

      try {
        copied = document.execCommand('copy');
      } catch (_error) {
        copied = false;
      }

      textArea.remove();
      return copied;
    };

    const setupDiscountCodeCopy = (trigger) => {
      if (!(trigger instanceof HTMLElement) || trigger.dataset.copyReady === 'true') return;
      trigger.dataset.copyReady = 'true';

      const feedback =
        trigger.parentElement?.querySelector('[data-bundle-discount-copy-feedback]') instanceof HTMLElement
          ? trigger.parentElement.querySelector('[data-bundle-discount-copy-feedback]')
          : null;
      let feedbackTimeout;

      const handleCopy = async () => {
        const copied = await copyTextToClipboard(trigger.dataset.copyText || '');
        window.clearTimeout(feedbackTimeout);
        trigger.classList.toggle('bundle-directory__discount-copy--copied', copied);

        feedbackTimeout = window.setTimeout(() => {
          trigger.classList.remove('bundle-directory__discount-copy--copied');
        }, 1800);
      };

      trigger.addEventListener('click', handleCopy);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        handleCopy();
      });
    };

    document.querySelectorAll('[data-bundle-discount-copy]').forEach((button) => {
      setupDiscountCodeCopy(button);
    });

    if (document.querySelector('[data-bundle-progressive]')) return;

    const BUNDLE_FILTER_WRAPPERS = '[data-bundle-celebration-filter-wrapper], [data-bundle-theme-filter-wrapper]';

    const FOCUSABLE_SELECTOR =
      'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';

    const isFocusableDisplayed = (el) => {
      if (!(el instanceof HTMLElement)) return false;
      if (el.matches('.bundle-directory__native-select-hidden')) return false;
      if (el.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      let p = el.parentElement;
      while (p) {
        if (p.getAttribute('aria-hidden') === 'true') return false;
        p = p.parentElement;
      }
      return true;
    };

    const listDocumentFocusables = () => {
      return /** @type {HTMLElement[]} */ (
        Array.from(document.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
          (n) => n instanceof HTMLElement && isFocusableDisplayed(n)
        )
      );
    };

    const bindBundleFilterDropdownGlobals = () => {
      if (window.__bundleFilterDropdownGlobals) return;
      window.__bundleFilterDropdownGlobals = true;

      document.addEventListener('mousedown', (e) => {
        const target = /** @type {Node} */ (e.target);
        document.querySelectorAll(BUNDLE_FILTER_WRAPPERS).forEach((wrap) => {
          const isOpen =
            wrap.classList.contains('bundle-directory__celebration-field--open') ||
            wrap.classList.contains('bundle-directory__theme-field--open');
          if (!isOpen) return;
          if (!wrap.contains(target)) {
            const panel =
              wrap.querySelector('[data-bundle-celebration-panel]') || wrap.querySelector('[data-bundle-theme-panel]');
            const trigger =
              wrap.querySelector('[data-bundle-celebration-trigger]') ||
              wrap.querySelector('[data-bundle-theme-trigger]');
            trigger?.setAttribute('aria-expanded', 'false');
            wrap.classList.remove('bundle-directory__celebration-field--open', 'bundle-directory__theme-field--open');
            panel?.setAttribute('aria-hidden', 'true');
          }
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        document.querySelectorAll(BUNDLE_FILTER_WRAPPERS).forEach((wrap) => {
          const isOpen =
            wrap.classList.contains('bundle-directory__celebration-field--open') ||
            wrap.classList.contains('bundle-directory__theme-field--open');
          if (!isOpen) return;
          const panel =
            wrap.querySelector('[data-bundle-celebration-panel]') || wrap.querySelector('[data-bundle-theme-panel]');
          const trigger =
            wrap.querySelector('[data-bundle-celebration-trigger]') ||
            wrap.querySelector('[data-bundle-theme-trigger]');
          trigger?.setAttribute('aria-expanded', 'false');
          wrap.classList.remove('bundle-directory__celebration-field--open', 'bundle-directory__theme-field--open');
          panel?.setAttribute('aria-hidden', 'true');
          trigger?.focus();
        });
      });
    };

    /**
     * @param {object} cfg
     * @param {HTMLSelectElement} cfg.select
     * @param {HTMLElement} cfg.wrapper
     * @param {string} cfg.openClass
     * @param {string} cfg.dirtyClass
     * @param {string} cfg.triggerSelector
     * @param {string} cfg.panelSelector
     * @param {string} cfg.listSelector
     * @param {string} cfg.searchSelector
     * @param {string} cfg.displaySelector
     */
    const setupBundleCustomSelect = (cfg) => {
      const {
        select,
        wrapper,
        openClass,
        dirtyClass,
        triggerSelector,
        panelSelector,
        listSelector,
        searchSelector,
        displaySelector,
      } = cfg;

      if (wrapper.dataset.bundleCustomSelectReady === 'true') return;
      wrapper.dataset.bundleCustomSelectReady = 'true';

      bindBundleFilterDropdownGlobals();

      const trigger = wrapper.querySelector(triggerSelector);
      const panel = wrapper.querySelector(panelSelector);
      const list = wrapper.querySelector(listSelector);
      const searchInput = wrapper.querySelector(searchSelector);
      const display = wrapper.querySelector(displaySelector);

      if (!trigger || !panel || !list || !display) return;

      const setOpen = (open) => {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        wrapper.classList.toggle(openClass, open);
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      };

      const disabled = select.options.length <= 1;
      select.disabled = disabled;
      trigger.disabled = disabled;
      if (searchInput instanceof HTMLInputElement) searchInput.disabled = disabled;
      wrapper.classList.toggle('bundle-directory__toolbar-item--disabled', disabled);

      if (disabled) setOpen(false);

      const syncDirtyClass = () => {
        wrapper.classList.toggle(dirtyClass, select.value !== '');
      };

      const filterList = (raw) => {
        const q = raw.trim().toLowerCase();
        list.querySelectorAll('[data-bundle-option-row]').forEach((row) => {
          const label = row.dataset.bundleOptionLabel || '';
          row.hidden = q !== '' && !label.includes(q);
        });
      };

      const getOptionButtons = () => {
        /** @type {HTMLButtonElement[]} */
        const out = [];
        list.querySelectorAll('.bundle-directory__dropdown-option').forEach((btn) => {
          const row = btn.closest('[data-bundle-option-row]');
          if (row instanceof HTMLElement && !row.hidden && btn instanceof HTMLButtonElement) {
            out.push(btn);
          }
        });
        return out;
      };

      wrapper.addEventListener('keydown', (e) => {
        if (!wrapper.classList.contains(openClass)) return;
        if (!wrapper.contains(document.activeElement)) return;

        if (e.key === 'Tab') {
          e.preventDefault();
          const all = listDocumentFocusables();
          if (e.shiftKey) {
            const firstIn = all.findIndex((el) => wrapper.contains(el));
            const prev = firstIn > 0 ? all[firstIn - 1] : null;
            setOpen(false);
            (prev || trigger).focus();
          } else {
            let lastIn = -1;
            for (let i = 0; i < all.length; i++) {
              if (wrapper.contains(all[i])) lastIn = i;
            }
            const next = lastIn >= 0 && lastIn < all.length - 1 ? all[lastIn + 1] : null;
            setOpen(false);
            (next || trigger).focus();
          }
          return;
        }

        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

        const opts = getOptionButtons();
        const active = document.activeElement;

        if (active === trigger) {
          e.preventDefault();
          if (e.key === 'ArrowDown') {
            if (searchInput instanceof HTMLInputElement) searchInput.focus();
            else if (opts[0]) opts[0].focus();
          } else if (opts.length) {
            opts[opts.length - 1].focus();
          }
          return;
        }

        if (searchInput && active === searchInput) {
          e.preventDefault();
          if (e.key === 'ArrowDown' && opts[0]) opts[0].focus();
          else if (e.key === 'ArrowUp' && opts.length) opts[opts.length - 1].focus();
          return;
        }

        const optIdx = opts.indexOf(/** @type {HTMLButtonElement} */ (active));
        if (optIdx === -1) return;

        e.preventDefault();
        if (e.key === 'ArrowDown') {
          if (optIdx < opts.length - 1) opts[optIdx + 1].focus();
          else if (searchInput instanceof HTMLInputElement) searchInput.focus();
          else if (opts[0]) opts[0].focus();
        } else if (optIdx > 0) {
          opts[optIdx - 1].focus();
        } else if (searchInput instanceof HTMLInputElement) {
          searchInput.focus();
        } else if (opts.length) {
          opts[opts.length - 1].focus();
        }
      });

      const rebuildList = () => {
        list.innerHTML = '';
        Array.from(select.options).forEach((opt) => {
          const li = document.createElement('li');
          li.setAttribute('role', 'presentation');
          li.dataset.bundleOptionRow = 'true';
          li.dataset.bundleOptionLabel = opt.textContent.toLowerCase();

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bundle-directory__dropdown-option';
          btn.setAttribute('role', 'option');
          btn.dataset.value = opt.value;
          btn.textContent = opt.textContent;
          btn.setAttribute('aria-selected', opt.value === select.value ? 'true' : 'false');

          btn.addEventListener('click', () => {
            select.value = opt.value;
            const selectedOpt = select.options[select.selectedIndex];
            display.textContent = selectedOpt ? selectedOpt.textContent : '';
            syncDirtyClass();
            list.querySelectorAll('[role="option"]').forEach((b) => {
              b.setAttribute('aria-selected', b.dataset.value === select.value ? 'true' : 'false');
            });
            if (searchInput) searchInput.value = '';
            filterList('');
            setOpen(false);
            select.dispatchEvent(new Event('change', { bubbles: true }));
            trigger.focus();
          });

          li.appendChild(btn);
          list.appendChild(li);
        });
      };

      const updateDisplay = () => {
        const opt = select.options[select.selectedIndex];
        display.textContent = opt ? opt.textContent : '';
        syncDirtyClass();
        list.querySelectorAll('[role="option"]').forEach((b) => {
          b.setAttribute('aria-selected', b.dataset.value === select.value ? 'true' : 'false');
        });
      };

      const togglePanelFromUser = () => {
        const willOpen = !wrapper.classList.contains(openClass);
        setOpen(willOpen);
        if (willOpen && searchInput) {
          searchInput.value = '';
          filterList('');
        }
      };

      trigger.addEventListener('click', togglePanelFromUser);

      trigger.addEventListener('keydown', (e) => {
        if (e.key !== ' ') return;
        e.preventDefault();
        togglePanelFromUser();
      });

      searchInput?.addEventListener('input', () => {
        filterList(searchInput.value);
      });

      select.addEventListener('change', updateDisplay);

      rebuildList();
      updateDisplay();
    };

    const directories = document.querySelectorAll('[data-bundle-directory]');

    directories.forEach((directory) => {
      const root = directory.closest('.bundle-directory');
      const input = directory.querySelector('[data-bundle-filter-input]');
      const themeFilter = directory.querySelector('[data-bundle-theme-filter]');
      const themeFilterWrapper = directory.querySelector('[data-bundle-theme-filter-wrapper]');
      const celebrationFilter = directory.querySelector('[data-bundle-celebration-filter]');
      const celebrationFilterWrapper = directory.querySelector('[data-bundle-celebration-filter-wrapper]');
      const cards = root ? Array.from(root.querySelectorAll('[data-bundle-card]')) : [];
      const noResults = root?.querySelector('[data-bundle-no-results]');
      const pagination = root?.querySelector('[data-bundle-pagination]');
      const loadMoreButton = pagination?.querySelector('[data-bundle-load-more]');
      const progressBar = pagination?.querySelector('[data-bundle-progress-bar]');
      const progressText = pagination?.querySelector('[data-bundle-progress-text]');
      const pageSize = Number.parseInt(pagination?.dataset.pageSize || '24', 10);
      let visibleLimit = pageSize;

      /* if (!root || !input || !cards.length) return; */
      if (!root || !cards.length) return;

      cards.sort((left, right) => {
        const leftHasImage = left.dataset.bundleHasImage === 'true';
        const rightHasImage = right.dataset.bundleHasImage === 'true';

        if (leftHasImage !== rightHasImage) {
          return leftHasImage ? -1 : 1;
        }

        const leftOrder = Number.parseInt(left.dataset.bundleSortOrder || '0', 10);
        const rightOrder = Number.parseInt(right.dataset.bundleSortOrder || '0', 10);

        return leftOrder - rightOrder;
      });

      cards.forEach((card) => {
        card.parentElement?.append(card);
      });

      if (themeFilter && themeFilterWrapper) {
        const themeOptions = new Map();

        cards.forEach((card) => {
          const themePairs = card.dataset.bundleThemePairs?.split('||') || [];
          const cardThemes = new Set();

          themePairs.forEach((pair) => {
            const separatorIndex = pair.indexOf('::');
            if (separatorIndex === -1) return;

            const handle = pair.slice(0, separatorIndex);
            const label = pair.slice(separatorIndex + 2);

            if (!handle || !label || cardThemes.has(handle)) return;

            cardThemes.add(handle);
            const option = themeOptions.get(handle) || { label, count: 0 };
            option.count += 1;
            themeOptions.set(handle, option);
          });
        });

        if (themeOptions.size > 0) {
          Array.from(themeOptions.entries())
            .sort((a, b) => a[1].label.localeCompare(b[1].label))
            .forEach(([value, optionData]) => {
              const option = document.createElement('option');
              option.value = value;
              option.textContent = `${optionData.label} (${optionData.count})`;
              themeFilter.appendChild(option);
            });

          themeFilterWrapper.classList.remove('hidden');
        }

        setupBundleCustomSelect({
          select: themeFilter,
          wrapper: themeFilterWrapper,
          openClass: 'bundle-directory__theme-field--open',
          dirtyClass: 'bundle-directory__theme-field--dirty',
          triggerSelector: '[data-bundle-theme-trigger]',
          panelSelector: '[data-bundle-theme-panel]',
          listSelector: '[data-bundle-theme-options]',
          searchSelector: '[data-bundle-theme-search]',
          displaySelector: '[data-bundle-theme-display]',
        });
      }

      if (celebrationFilter && celebrationFilterWrapper) {
        const celebrationOptions = new Map();

        cards.forEach((card) => {
          const celebrationPairs = card.dataset.bundleCelebrationPairs?.split('||') || [];
          const cardCelebrations = new Set();

          celebrationPairs.forEach((pair) => {
            const separatorIndex = pair.indexOf('::');
            if (separatorIndex === -1) return;

            const handle = pair.slice(0, separatorIndex);
            const label = pair.slice(separatorIndex + 2);

            if (!handle || !label || cardCelebrations.has(handle)) return;

            cardCelebrations.add(handle);
            const option = celebrationOptions.get(handle) || { label, count: 0 };
            option.count += 1;
            celebrationOptions.set(handle, option);
          });
        });

        if (celebrationOptions.size > 0) {
          Array.from(celebrationOptions.entries())
            .sort((a, b) => a[1].label.localeCompare(b[1].label))
            .forEach(([value, optionData]) => {
              const option = document.createElement('option');
              option.value = value;
              option.textContent = `${optionData.label} (${optionData.count})`;
              celebrationFilter.appendChild(option);
            });

          celebrationFilterWrapper.classList.remove('hidden');
        }

        setupBundleCustomSelect({
          select: celebrationFilter,
          wrapper: celebrationFilterWrapper,
          openClass: 'bundle-directory__celebration-field--open',
          dirtyClass: 'bundle-directory__celebration-field--dirty',
          triggerSelector: '[data-bundle-celebration-trigger]',
          panelSelector: '[data-bundle-celebration-panel]',
          listSelector: '[data-bundle-celebration-options]',
          searchSelector: '[data-bundle-celebration-search]',
          displaySelector: '[data-bundle-celebration-display]',
        });
      }

      const updatePagination = (visibleCount, totalCount) => {
        if (!pagination) return;

        const percentage = totalCount > 0 ? (visibleCount / totalCount) * 100 : 0;
        const progressTemplate = pagination.dataset.progressTemplate || '__items__ / __total__';

        if (progressBar) {
          progressBar.style.width = `${percentage}%`;
          progressBar.setAttribute('aria-valuemax', String(totalCount));
          progressBar.setAttribute('aria-valuenow', String(visibleCount));
        }

        if (progressText) {
          progressText.textContent = progressTemplate
            .replace('__items__', String(visibleCount))
            .replace('__total__', String(totalCount));
        }

        if (loadMoreButton) {
          loadMoreButton.hidden = visibleCount >= totalCount;
        }
      };

      const applyFilter = (resetPagination = false) => {
        if (resetPagination) visibleLimit = pageSize;

        const query = (input?.value || '').trim().toLowerCase();
        const selectedTheme = themeFilter?.value || '';
        const selectedCelebration = celebrationFilter?.value || '';
        const matchingCards = [];

        cards.forEach((card) => {
          const matchesName = query === '' || card.dataset.bundleName?.includes(query);
          const matchesTheme =
            selectedTheme === '' || (card.dataset.bundleThemes || '').split('||').includes(selectedTheme);
          const matchesCelebration =
            selectedCelebration === '' ||
            (card.dataset.bundleCelebrations || '').split('||').includes(selectedCelebration);
          const matches = matchesName && matchesTheme && matchesCelebration;
          card.classList.toggle('bundle-directory__item--filtered-out', !matches);
          if (matches) matchingCards.push(card);
        });

        matchingCards.forEach((card, index) => {
          card.classList.toggle('bundle-directory__item--page-hidden', index >= visibleLimit);
        });

        const visibleCount = Math.min(visibleLimit, matchingCards.length);
        updatePagination(visibleCount, matchingCards.length);

        if (noResults) {
          noResults.classList.toggle('hidden', matchingCards.length > 0);
        }

        return matchingCards;
      };

      /* input.addEventListener('input', applyFilter); */
      themeFilter?.addEventListener('change', () => applyFilter(true));
      celebrationFilter?.addEventListener('change', () => applyFilter(true));

      loadMoreButton?.addEventListener('click', () => {
        const previouslyVisible = visibleLimit;
        visibleLimit += pageSize;
        const matchingCards = applyFilter();
        const firstRevealedCard = matchingCards[previouslyVisible];
        const firstRevealedLink = firstRevealedCard?.querySelector('a[href]');
        firstRevealedLink?.focus({ preventScroll: true });
      });

      applyFilter();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-related-by-variant-proxy"] && !Shopify.designMode) return;
  try {
    class RelatedByVariantDialog extends HTMLElement {
    connectedCallback() {
      this.dialogComponent = this.querySelector('dialog-component');
      this.trigger = this.querySelector('[data-related-trigger]');
      this.loadingStatus = this.querySelector('[data-related-loading-status]');
      this.closeButton = this.querySelector('[data-related-close]');
      this.state = this.querySelector('[data-related-state]');
      this.carousel = this.querySelector('[data-related-carousel]');
      this.grid = this.querySelector('[data-related-grid]');
      this.dialog = this.querySelector('dialog');
      this.proxyUrl = this.dataset.proxyUrl || '/apps/api/related-by-variant';
      this.shopDomain = this.dataset.shopDomain || window.location.hostname;
      this.storefrontAccessToken = this.dataset.storefrontAccessToken || '';
      this.storefrontApiVersion = this.dataset.storefrontApiVersion || '2026-07';
      this.cardSectionId = this.dataset.cardSectionId || 'ajax-wishlist-product-card';
      this.currentVariantId = this.dataset.initialVariantId || '';
      this.currentVariantAvailable = this.dataset.initialVariantAvailable === 'true';
      this.itemsCache = new Map();
      this.markupCache = new Map();
      this.abortController = null;

      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleVariantUpdate = this.handleVariantUpdate.bind(this);

      this.trigger?.addEventListener('click', this.handleTriggerClick);
      this.closeButton?.addEventListener('click', this.handleCloseClick);
      document.addEventListener('variant:update', this.handleVariantUpdate);
      this.syncVisibility();
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.handleTriggerClick);
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      document.removeEventListener('variant:update', this.handleVariantUpdate);
      this.abortController?.abort();
    }

    async handleTriggerClick(event) {
      event.preventDefault();
      this.dialogComponent?.showDialog();
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      await this.loadForVariant(this.currentVariantId);
    }

    handleCloseClick(event) {
      event.preventDefault();
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
      }
      this.dialogComponent?.closeDialog();
    }

    async handleVariantUpdate(event) {
      const variantId = event?.detail?.resource?.id ? String(event.detail.resource.id) : '';
      if (!variantId) return;

      this.currentVariantId = variantId;
      this.currentVariantAvailable = event?.detail?.resource?.available === true;
      const hasRelatedProducts = await this.syncVisibility();

      if (this.dialog?.open) {
        if (this.currentVariantAvailable || !hasRelatedProducts) {
          this.handleCloseClick(new Event('click'));
          return;
        }
        await this.loadForVariant(variantId);
      }
    }

    async loadForVariant(variantId) {
      if (!variantId) {
        this.renderState('error');
        return false;
      }

      const cacheKey = String(variantId);
      if (this.markupCache.has(cacheKey)) {
        const cachedMarkup = this.markupCache.get(cacheKey);
        if (cachedMarkup) {
          this.renderGrid(cachedMarkup);
        } else {
          this.renderState('empty');
        }
        return Boolean(cachedMarkup);
      }

      this.abortController?.abort();
      this.abortController = new AbortController();

      this.renderState('loading');

      try {
        const items = await this.getItemsForVariant(cacheKey, this.abortController.signal);

        if (items.length === 0) {
          this.renderState('empty');
          this.markupCache.set(cacheKey, '');
          return false;
        }

        const hydratedItems = await this.hydrateItemsWithHandles(items, this.abortController.signal);
        const markup = await this.fetchCardMarkup(hydratedItems, this.abortController.signal);

        if (!markup.trim()) {
          this.renderState('empty');
          this.markupCache.set(cacheKey, '');
          return false;
        }

        this.markupCache.set(cacheKey, markup);
        this.renderGrid(markup);
        return true;
      } catch (error) {
        if (error?.name === 'AbortError') return false;
        this.renderState('error');
        return false;
      }
    }

    async getItemsForVariant(variantId, signal) {
      const cacheKey = String(variantId);

      if (this.itemsCache.has(cacheKey)) {
        const cachedItems = this.itemsCache.get(cacheKey) || [];
        return cachedItems;
      }

      const items = await this.fetchProxyPayload(cacheKey, signal);
      if (items.length > 0) {
        this.itemsCache.set(cacheKey, items);
      }
      return items;
    }

    async fetchProxyPayload(variantId, signal) {
      const requestUrl = new URL(this.proxyUrl, window.location.origin);
      requestUrl.searchParams.set('variant_gid', this.buildVariantGid(variantId));

      const response = await fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
        signal,
      });

      if (!response.ok) {
        throw new Error(`Related-by-variant proxy request failed with status ${response.status}.`);
      }

      const payload = await response.json();
      return Array.isArray(payload?.data)
        ? payload.data.filter((item) => item?.product_gid && item?.variant_gid)
        : [];
    }

    async hydrateItemsWithHandles(items, signal) {
      const normalizedItems = items
        .filter((item) => item?.product_gid && item?.variant_gid)
        .map((item) => ({
          ...item,
          handle: typeof item.handle === 'string' ? item.handle.trim() : '',
        }));

      const missingHandleItems = normalizedItems.filter((item) => !item.handle);

      if (missingHandleItems.length === 0) {
        return normalizedItems;
      }

      if (!this.storefrontAccessToken) {
        return normalizedItems;
      }

      const productsById = await this.fetchProductsByGid(
        missingHandleItems.map((item) => item.product_gid),
        signal
      );

      return normalizedItems.map((item) => {
        if (item.handle) return item;

        const product = productsById.get(item.product_gid);
        return {
          ...item,
          handle: typeof product?.handle === 'string' ? product.handle.trim() : '',
        };
      });
    }

    async fetchProductsByGid(productGids, signal) {
      const uniqueIds = [...new Set(productGids.filter(Boolean))];

      if (uniqueIds.length === 0) {
        return new Map();
      }

      const response = await fetch(`https://${this.shopDomain}/api/${this.storefrontApiVersion}/graphql.json`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
        },
        body: JSON.stringify({
          query: `
            query RelatedByVariantProducts($ids: [ID!]!) {
              nodes(ids: $ids) {
                ... on Product {
                  id
                  handle
                }
              }
            }
          `,
          variables: {
            ids: uniqueIds,
          },
        }),
        signal,
      });

      if (!response.ok) {
        throw new Error(`Storefront GraphQL request failed with status ${response.status}.`);
      }

      const payload = await response.json();
      const nodes = Array.isArray(payload?.data?.nodes) ? payload.data.nodes : [];

      return new Map(
        nodes
          .filter((node) => node && typeof node.id === 'string' && typeof node.handle === 'string')
          .map((node) => [node.id, node])
      );
    }

    async fetchCardMarkup(items, signal) {
      const cards = await Promise.all(
        items.map(async (item, index) => {
          const variantId = this.extractResourceId(item.variant_gid);
          const productHandle = typeof item.handle === 'string' ? item.handle.trim() : '';

          if (!productHandle || !variantId) {
            return '';
          }

          const cardUrl = new URL(`/products/${productHandle}`, window.location.origin);
          cardUrl.searchParams.set('section_id', this.cardSectionId);
          cardUrl.searchParams.set('variant', variantId);

          const response = await fetch(cardUrl.toString(), {
            credentials: 'same-origin',
            signal,
          });

          if (!response.ok) {
            throw new Error(`Related product card request failed with status ${response.status}.`);
          }

          const markup = await response.text();

          if (!markup.trim()) {
            return '';
          }

          const uniqueScope = `shopify-section-${this.cardSectionId}-${variantId}-${index}`;
          const normalizedMarkup = markup.replaceAll(`shopify-section-${this.cardSectionId}`, uniqueScope);
          const carouselMarkup = normalizedMarkup.replaceAll(
            'sizes="(min-width: 750px) 360px, 100vw"',
            'sizes="(min-width: 750px) 566px, 100vw"'
          );

          return `<div class="nw-related-by-variant__card swiper-slide">${carouselMarkup}</div>`;
        })
      );

      return cards.filter(Boolean).join('');
    }

    renderGrid(markup) {
      if (!this.state || !this.carousel || !this.grid) return;
      this.state.hidden = true;
      this.carousel.hidden = false;
      this.grid.innerHTML = markup;
      this.dispatchEvent(new CustomEvent('product-recommendations:loaded', { bubbles: true }));
    }

    renderState(type) {
      if (!this.state || !this.carousel || !this.grid) return;

      const messages = {
        loading: this.dataset.loadingLabel || 'Loading related products...',
        empty: this.dataset.emptyLabel || 'No related products available right now.',
        error: this.dataset.errorLabel || 'Related products could not be loaded right now.',
      };

      this.carousel.hidden = true;
      this.grid.innerHTML = '';
      this.state.hidden = false;
      this.state.textContent = messages[type] || messages.error;
    }

    async syncVisibility() {
      const variantId = this.currentVariantId;
      this.hidden = true;
      if (this.dialogComponent) this.dialogComponent.hidden = true;
      if (this.loadingStatus) this.loadingStatus.hidden = true;
      this.trigger?.setAttribute('aria-hidden', 'true');

      if (this.currentVariantAvailable) {
        this.abortController?.abort();
        return false;
      }

      this.abortController?.abort();
      const abortController = new AbortController();
      this.abortController = abortController;
      this.hidden = false;
      if (this.loadingStatus) this.loadingStatus.hidden = false;

      let hasRelatedProducts = false;

      try {
        const items = await this.getItemsForVariant(variantId, this.abortController.signal);
        hasRelatedProducts = items.length > 0;
      } catch (error) {
        if (error?.name !== 'AbortError') {
          hasRelatedProducts = false;
        }
      }

      if (this.abortController !== abortController || this.currentVariantId !== variantId) return false;

      const canShowTrigger = hasRelatedProducts && !this.currentVariantAvailable && this.currentVariantId === variantId;

      this.hidden = !canShowTrigger;
      if (this.dialogComponent) this.dialogComponent.hidden = !canShowTrigger;
      if (this.loadingStatus) this.loadingStatus.hidden = true;
      this.trigger?.setAttribute('aria-hidden', canShowTrigger ? 'false' : 'true');
      return canShowTrigger;
    }

    buildVariantGid(variantId) {
      return `gid://shopify/ProductVariant/${variantId}`;
    }

    extractResourceId(gid) {
      if (typeof gid !== 'string') return '';
      const segments = gid.split('/');
      return segments[segments.length - 1] || '';
    }
  }

  if (!customElements.get('related-by-variant-dialog')) {
    customElements.define('related-by-variant-dialog', RelatedByVariantDialog);
  }
  } catch(e) { console.error(e); }
})();

})();
